module.exports = __webpack_public_path__ + "img/yes_hover.4710e81e.png";